import { ReactComponent as AlertPrimaryImg } from "assets/images/alert-primary.svg";
import { ReactComponent as AlertSecondaryImg } from "assets/images/alert-secondary.svg";
import { ReactComponent as AlertInfoImg } from "assets/images/alert-info.svg";
import { ReactComponent as AlertSuccessImg } from "assets/images/alert-success.svg";
import { ReactComponent as AlertDangerImg } from "assets/images/alert-danger.svg";
import { ReactComponent as AlertWarningImg } from "assets/images/alert-warning.svg";
import Referralcoordinator from "containers/referralcoordinator";

export const BASE_URL = process.env.REACT_APP_API_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const GRANT_TYPE = Object.freeze({
  PASSWORD: "password",
  REFRESH_TOKEN: "refresh_token",
});
export const initialMetaForTable = {
  page: 1,
  perPage: 10,
  search: "",
};

export const DEBOUNCE_DELAY = 700;

export const toastContainerProps = {
  hideProgressBar: true,
  closeButton: false,
  autoClose: 5000,
  limit: 2,
  position: "bottom-right",
  closeOnClick: false,
};

export const alertTypes = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
};

export const alertIcons = {
  [alertTypes.INFO]: <AlertInfoImg />,
  [alertTypes.DANGER]: <AlertDangerImg />,
  [alertTypes.WARNING]: <AlertWarningImg />,
  [alertTypes.SUCCESS]: <AlertSuccessImg />,
  [alertTypes.PRIMARY]: <AlertPrimaryImg />,
  [alertTypes.SECONDARY]: <AlertSecondaryImg />,
};
export const question_type = {
  dropdown: "dropdown",
  multiple_choice: "multiple_choice",
  input: "text",
  checkbox: "checkbox",
  text: "text",
  multi_select: "multi_select",
  dynamic: "dynamic",
  date: "date",
  phone: "phone",
  time_range: "time_range",
  file: "file",
  score: "dropdown",
};

export const LOGIN_ROLES = {
  outreachleader: "OutreachLeader",
  outreachstaff: "OutreachStaff",
  referralcoordinator: "ReferralCoordinator",
};
export const martial_statusOptions = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
  { value: "separated", label: "Separated" },
  { value: "domestic_partner", label: "Domestic Partner" },
  { value: "prefer_not_say", label: "Prefer Not to Say" },
];
export const referringProviderOptions = [
  { value: "maria_ramirez", label: "Maria Ramirez, Program Director" },
  { value: "david_nguyen", label: "David Nguyen, Outreach Manager" },
  { value: "lisa_tran", label: "Lisa Tran, Shelter Coordinator" },
  { value: "jamal_wright", label: "Jamal Wright, Community Lead" },
  { value: "rachel_lee", label: "Rachel Lee, Program Director" },
];
export const referralProgramOptions = [
  { value: "ecm", label: "ECM" },
  { value: "cs_housing", label: "CalAIM - CSS Housing Navigation" },
  { value: "recuperative_care", label: "CalAIM - CSS Recup" },
  { value: "short_term_hospitalization", label: "Short Term Hospitalization" },
  {
    value: "css_tenancy_sustainability",
    label: "CalAIM - CSS Tenancy/Sustainability",
  },
];

export const existingProgramEnrollments = [
  { value: "bay_area_housing_support", label: "Bay Area Housing Support" },
  { value: "la_homeless_aid", label: "Los Angeles Homeless Aid" },
  { value: "sacramento_shelter_network", label: "Sacramento Shelter Network" },
  { value: "oakland_outreach_services", label: "Oakland Outreach Services" },
  { value: "san_diego_safe_haven", label: "San Diego Safe Haven" },
];

export const programTypes = [
  { value: "ecm", label: "CalAIM - ECM" },
  { value: "cs_housing", label: "CalAIM - CSS Housing Navigation" },
  { value: "recuperative_care", label: "CalAIM - CSS Recup" },
  {
    value: "short_term_post_hospitalization",
    label: "CalAIM - CSS Short-Term Post-Hospitalization",
  },
  {
    value: "css_tenancy_sustainability",
    label: "CalAIM - CSS Tenancy/Sustainability",
  },
  { value: "no", label: "None" },
];

export const REFERRAL_STATUS = {
  Submitted: "submitted",
  Pending: "pending",
  Approved: "approved",
  Denied: "denied",
};
export const CURRENT_LIVING_SITUATION = [
  { value: "street", label: "Street" },
  { value: "shelter", label: "Shelter" },
  { value: "recuperative_care", label: "Recuperative Care" },
  { value: "vehicle", label: "Vehicle" },
  { value: "couch_surfing", label: "Couch Surfing" },
  { value: "permanent_housing", label: "Permanent Housing" },
  { value: "other", label: "Other" },
];

export const US_STATES = [
  { label: "AL", value: "AL" },
  { label: "AK", value: "AK" },
  { label: "AZ", value: "AZ" },
  { label: "AR", value: "AR" },
  { label: "CA", value: "CA" },
  { label: "CO", value: "CO" },
  { label: "CT", value: "CT" },
  { label: "DE", value: "DE" },
  { label: "FL", value: "FL" },
  { label: "GA", value: "GA" },
  { label: "HI", value: "HI" },
  { label: "ID", value: "ID" },
  { label: "IL", value: "IL" },
  { label: "IN", value: "IN" },
  { label: "IA", value: "IA" },
  { label: "KS", value: "KS" },
  { label: "KY", value: "KY" },
  { label: "LA", value: "LA" },
  { label: "ME", value: "ME" },
  { label: "MD", value: "MD" },
  { label: "MA", value: "MA" },
  { label: "MI", value: "MI" },
  { label: "MN", value: "MN" },
  { label: "MS", value: "MS" },
  { label: "MO", value: "MO" },
  { label: "MT", value: "MT" },
  { label: "NE", value: "NE" },
  { label: "NV", value: "NV" },
  { label: "NH", value: "NH" },
  { label: "NJ", value: "NJ" },
  { label: "NM", value: "NM" },
  { label: "NY", value: "NY" },
  { label: "NC", value: "NC" },
  { label: "ND", value: "ND" },
  { label: "OH", value: "OH" },
  { label: "OK", value: "OK" },
  { label: "OR", value: "OR" },
  { label: "PA", value: "PA" },
  { label: "RI", value: "RI" },
  { label: "SC", value: "SC" },
  { label: "SD", value: "SD" },
  { label: "TN", value: "TN" },
  { label: "TX", value: "TX" },
  { label: "UT", value: "UT" },
  { label: "VT", value: "VT" },
  { label: "VA", value: "VA" },
  { label: "WA", value: "WA" },
  { label: "WV", value: "WV" },
  { label: "WI", value: "WI" },
  { label: "WY", value: "WY" },
];

export const ORGANIZATION_TYPES = [
  { label: "Hospital", value: "hospital" },
  {
    label: "Community Based Organization",
    value: "community_based_organization",
  },
  { label: "Healthcare Provider", value: "healthcare_provider" },
  { label: "Internal", value: "internal" },
  { label: "Medical Group/IPA", value: "medical_group/ipa" },
  { label: "SNF", value: "snf" },
  { label: "Health Plan", value: "health_plan" },
];
export const normalizeInput = (value, previousValue = 0) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};
// export const POPULATION_FOCUSES = [
//   { value: "elderly", label: "Elderly" },
//   { value: "disabled", label: "Disabled" },
//   { value: "veterans", label: "Veterans" },
//   { value: "low_income", label: "Low-Income" },
//   { value: "other_focus", label: "Other" },
// ];

export const POPULATION_FOCUSES = [
  {
    value: "adult_birth_equity",
    label: "Adult - Birth Equity Population of Focus",
  },
  {
    value: "adult_homeless_individual",
    label:
      "Adult - Individual Experiencing Homelessness Adults without Dependent Children Youth Living with Them Experiencing Homelessness",
  },
  {
    value: "adult_homeless_family",
    label: "Adult - Individual Experiencing Homelessness Homeless Family",
  },
  {
    value: "adult_hospital_ed_risk",
    label:
      "Adult - Individuals at Risk for Avoidable Hospital or ED Utilization",
  },
  {
    value: "adult_ltc_risk",
    label:
      "Adult - Individuals Living in the Community and at Risk for LTC Institutionalization",
  },
  {
    value: "adult_incarceration_transition",
    label: "Adult - Individuals Transitioning from Incarceration",
  },
  {
    value: "adult_mental_health_sud",
    label:
      "Adult - Individuals with Serious Mental Health or Substance Use Disorder (SUD) Needs",
  },
  {
    value: "adult_nursing_facility_transition",
    label: "Adult - Nursing Facility Residents Transitioning to Community",
  },
  {
    value: "child_youth_birth_equity",
    label: "Child Youth - Birth Equity Population of Focus",
  },
  {
    value: "child_youth_ccs_additional_needs",
    label:
      "Child Youth - Enrolled in CCS or CCS WCM with Additional Needs Beyond the CCS Condition",
  },
  {
    value: "child_youth_homeless_family",
    label: "Child Youth - Individual Experiencing Homelessness Homeless Family",
  },
  {
    value: "child_youth_hospital_ed_risk",
    label:
      "Child Youth - Individuals at Risk for Avoidable Hospital or ED Utilization",
  },
  {
    value: "child_youth_homeless_unaccompanied",
    label:
      "Child Youth - Individuals Experiencing Homelessness Unaccompanied Children Youth Experiencing Homelessness",
  },
  {
    value: "child_youth_incarceration_transition",
    label: "Child Youth - Individuals Transitioning from Incarceration",
  },
  {
    value: "child_youth_mental_health_sud",
    label:
      "Child Youth - Individuals with Serious Mental Health or Substance Use Disorder (SUD) Needs",
  },
  {
    value: "child_youth_child_welfare",
    label: "Child Youth - Involved in Child Welfare",
  }
];

export const GENDER = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "othergender", label: "Other" },
  { value: "nonbinary", label: "Non-Binary" },
  {
    value: "prefernottosay",
    label: "Prefer Not to Say",
  },
  {
    value: "na",
    label: "NA",
  },
];
export const RACES = [
  { value: "asian", label: "Asian" },
  {
    value: "black_or_african_american",
    label: "Black or African American",
  },
  {
    value: "hispanic_or_latino",
    label: "Hispanic or Latino",
  },
  { value: "native_american", label: "Native American" },
  { value: "white", label: "White" },
  { value: "other", label: "Other" },
];
export const MARTIAL_STATUSES = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
  { value: "others", label: "Other" },
];
export const CONDITIONS = [
  { value: "diabetes", label: "Diabetes" },
  { value: "asthma", label: "Asthma" },
  { value: "bipolar_disorder", label: "Bipolar disorder" },
  {
    value: "chronic_congestive_heart_failure",
    label: "Chronic congestive heart failure",
  },
  { value: "chronic_kidney_disease", label: "Chronic kidney disease" },
  { value: "chronic_liver_disease", label: "Chronic liver disease" },
  {
    value: "chronic_obstructive_pulmonary_disease",
    label: "Chronic obstructive pulmonary disease",
  },
  { value: "coronary_artery_disease", label: "Coronary artery disease" },
  { value: "dementia", label: "Dementia" },
  { value: "hypertension", label: "Hypertension" },

  { value: "psychotic_disorders", label: "Psychotic disorders" },
  { value: "smi_or_sud_or_sed", label: "SMI or SUD or SED" },
  { value: "traumatic_brain_injury", label: "Traumatic brain injury" },
  {
    value: "0ther_clinical_chronic_conditions",
    label: "Other Clinical Chronic Conditions",
  },
  {
    value: "N/A",
    label: "N/A",
  },
];

export const referral_status = [
  { label: "Submitted", value: "submitted" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Denied", value: "denied" },
];

export const allConditions = [
  { value: "diabetes", label: "Diabetes" },
  { value: "asthma", label: "Asthma" },
  { value: "bipolar_disorder", label: "Bipolar disorder" },
  {
    value: "chronic_congestive_heart_failure",
    label: "Chronic congestive heart failure",
  },
  {
    value: "chronic_kidney_disease",
    label: "Chronic kidney disease",
  },
  {
    value: "chronic_liver_disease",
    label: "Chronic liver disease",
  },
  {
    value: "chronic_obstructive_pulmonary_disease",
    label: "Chronic obstructive pulmonary disease",
  },
  {
    value: "coronary_artery_disease",
    label: "Coronary artery disease",
  },
  { value: "dementia", label: "Dementia" },
  { value: "hypertension", label: "Hypertension" },
  {
    value: "psychotic_disorders",
    label: "Psychotic disorders",
  },
  {
    value: "smi_or_sud_or_sed",
    label: "SMI or SUD or SED",
  },
  {
    value: "traumatic_brain_injury",
    label: "Traumatic brain injury",
  },
  {
    value: "0ther_clinical_chronic_conditions",
    label: "Other Clinical Chronic Conditions",
  },
  {
    value: "N/A",
    label: "N/A",
  },
];
